import React, { Suspense, lazy } from "react";
import { Loader } from "@culturehq/components";

const CommentCallout = lazy(() => import("./CommentCallout"));

const LazyCommentCallout = ({ match: { params: { commentId } } }) => (
  <Suspense fallback={<Loader loading />}>
    <CommentCallout commentId={commentId} />
  </Suspense>
);

export default LazyCommentCallout;
